import { Ubication } from '../../../../common/components/modals/time-attendance-events/components/ubication';
import { requests } from '../apiAgent';

export const UbicationsAPI = {
    Get: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/ubications/keyboard-type')
            .then((response: Ubication[]) => response);
    },
};
